// extracted by extract-css-chunks-webpack-plugin
module.exports = {"tooltipZIndex":"3","tooltipSpacing":"10px","container":"a4roHlcm148e","currencyTitle":"Lr4ggyK-nYnh","currencyName":"+jcOpdNLAdUa"};